import { createAction, props } from '@ngrx/store';

export const authenticate = createAction(
  '[Auth] Authenticate',
  props<{ initPayload: string; supportedQuickActions?: string[]; userIdForAtInternet?: string }>(),
);
export const authenticateSuccess = createAction('[Auth] Authenticate Success');
export const authenticateFailure = createAction(
  '[Auth] Authenticate Failure',
  props<{ error: string; initPayloadErrored: string }>(),
);

export const stillAuthenticated = createAction('[Auth] Still Authenticated');
